<template>
   <div 
        class="video-item-com"
        v-loading="loading" 
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-color="#fff"
        element-loading-custom-class="custom-loading"
        element-loading-background="rgba(0, 0, 0, 0.5)">
     <video controls muted style="width: 100%;height: 100%;display: none;" :id="`videoContainer${item.id}`"></video>
     <div v-if="loadingError" class="refresh-btn" @click="initAliRtsFunc">
        <i class="el-icon-refresh"/>
        重新加载
    </div>
    <span class="user-name">{{ item.user.username }}</span>
   </div>
</template>
<script>
import { AliRTS } from 'aliyun-rts-sdk';
import { Loading } from 'element-ui'
import Vue from 'vue'

Vue.use(Loading)

export default {
   name: '',
   components: {
     
   },
   mixins: [],
   props: {
     item:{
        type:[String,Object],
        default: () => {}
     }
   },
   data() {
     return {
       aliRts: '',
       loading: true,
       loadingError: ''
     }
   },
   computed: {
     
   },
   watch: {
     
   },
   mounted() {
     this.initAliRtsFunc()
   },
   beforeDestroy(){
        if(this.aliRts){
            this.aliRts.unsubscribe();
        }
    },
   methods: {
     initAliRtsFunc(){
        this.loading = true;
        this.loadingError = ''
        if(!this.aliRts){
            this.aliRts = AliRTS.createClient();
            this.aliRts.isSupport({isReceiveVideo: true}).then(res => {
                console.log(res, 'isSupport')
            // 可用
            }).catch(err=> {
                console.log(`not support message: ${err.message}`);
            })

            this.aliRts.on("onError", (err)=> {
                document.getElementById(`videoContainer${this.item.id}`).style.display='none'
                this.loading = false;
                this.loadingError = true;
                console.log(err)
            })
        }
        this.aliRts.subscribe(this.item.play_url).then((remoteStream) => {
            this.loading = false
            document.getElementById(`videoContainer${this.item.id}`).style.display='block'
            // mediaElement是媒体标签audio或video
            remoteStream.play(document.getElementById(`videoContainer${this.item.id}`),{autoplay:true});
            
            // 调用 remoteStream.play 会将媒体流绑定到媒体标签并尝试自动播放，
            // 如不希望自动播放，可以传入第二个参数 {autoplay:false}，从2.2.4版本开始支持
            // remoteStream.play(mediaElement, {autoplay:false});
        }).catch((err) => {
            document.getElementById(`videoContainer${this.item.id}`).style.display='none'
            this.loading = false;
            this.loadingError = true;
            // 订阅失败
            console.log(err,'订阅失败')
        })
     }
   }
};
</script>
<style lang='scss'>
.video-item-com{
    position: relative;
    width: 100%;
    height: 100%;
}
.custom-loading{
    .el-loading-spinner .el-loading-text{
        color: #fff !important;
    }
}
.refresh-btn{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 86px;
    line-height: 24px;
    background: rgba(25, 31, 37, .65);
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
}
.user-name{
    width: 100%;
    padding-top: 20px;
    font-size: 18px;
    text-align: center;
    display: block;
    position: absolute;
    top: 0px;
}
</style>